module.exports = "/fonts/tarra-h2h-logotype-l-5c67eb874fb9d9f142d10c7a265e4631.svg";